import { APP_STARTUP, APP_STARTUP_SUCCESS } from "../../store/constants/general";
import { REFRESH_DATABASE_SUCCESS, REFRESH_DATABASE_FAILURE } from "../../store/constants/database";

import { put, takeLatest } from "redux-saga/effects";
import { refreshDatabase } from "../actions/database";

function* startApplication(action) {
  yield put(refreshDatabase());
}

function* setApplicationLoaded(action) {
  // Because we allow database not to be refreshed
  yield put({ type: APP_STARTUP_SUCCESS });
}

export default function* rootSaga() {
  yield takeLatest(APP_STARTUP, startApplication);
  yield takeLatest(REFRESH_DATABASE_SUCCESS, setApplicationLoaded);
  // Since we support Offline mode allow failed db refresh
  yield takeLatest(REFRESH_DATABASE_FAILURE, setApplicationLoaded);
}
